import { createContext, useContext } from 'react';
import type { DensityMode } from '@/modules/shared/hooks/useDensity';

interface DensityContextValue {
  density: DensityMode;
  toggleDensity: () => void;
  isCompact: boolean;
}

export const DensityContext = createContext<DensityContextValue>({
  density: 'comfortable',
  toggleDensity: () => {},
  isCompact: false,
});

export function useDensityContext() {
  return useContext(DensityContext);
}
